import './styles.css'
import Reports from './Reports'

export default Reports